module.exports = __webpack_public_path__ + "static/media/cabinet-1.1d48abf8.webp";